export default "__VITE_ASSET__dm1FEEGW__"